import React from 'react';
import { Navigate } from 'react-router-dom';

const RedirectIfGuest = ({ children }) => {
  const currentUser = sessionStorage.getItem('isLoggedIn');

  if (currentUser) {
    return <Navigate to="/" />;
  }

  return children;
};

export default RedirectIfGuest;
